import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Button, Grid, Typography } from '@the-platform-group/component-library'
import { Add as AddIcon } from '@the-platform-group/component-library/Icons'

import Spinner from 'components/Spinner'
import { ListPaper } from 'components/Paper'

import PromptFilters from './components/PromptFilters'
import PromptsTable from './components/PromptsTable'
import { useAgenticPrompts } from './hooks/useAgenticPrompts'
import { useDeleteAgenticPrompt } from './hooks/useDeleteAgenticPrompt'

const AgenticPromptsList = () => {
  const {
    prompts,
    filters,
    isLoading,
    handleSearch,
    handleCategoriesChange,
    handleStatusesChange,
  } = useAgenticPrompts()
  const { deletePrompt } = useDeleteAgenticPrompt()

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h3">AI Prompts</Typography>
        <Button component={Link} to="/ai-prompts/new" variant="contained" startIcon={<AddIcon />}>
          New prompt
        </Button>
      </Box>

      <Grid container direction="column" spacing={2}>
        <Grid item>
          <PromptFilters
            filters={filters}
            onSearch={handleSearch}
            onCategoriesChange={handleCategoriesChange}
            onStatusesChange={handleStatusesChange}
          />
        </Grid>

        {isLoading && !prompts.length ? (
          <Spinner />
        ) : (
          <Grid item>
            <ListPaper>
              <PromptsTable prompts={prompts} isLoading={isLoading} onDelete={deletePrompt} />
            </ListPaper>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default AgenticPromptsList
